// https://app.optimizely.com/v2/projects/19065870423/flags/manage/web-adverts-feature-toggle
export const WEB_ADVERT_FEATURE_TOGGLE = "web-adverts-feature-toggle";
export const DEV_FEATURE_VARIABLE = "devConfig";
export const PROD_FEATURE_VARIABLE = "prodConfig";
export const HOMEPAGE_PREFIX = "viewHome";

export const APP = {
  HOMEPAGE: "homepage",
  CATEGORY: "category",
  SEARCH: "search",
  PDP: "pdp",
  ORDER_CONFIRMATION: "orderConfirmation"
};

export const PLACEMENT = {
  MIDDLE: "midBanner",
  BOTTOM: "bottomBanner",
  SPONSORED_PRODUCTS: "inGrid"
};

export const BEACON = {
  ON_VIEW: "OnViewBeacon",
  ON_LOAD: "OnLoadBeacon",
  ON_CLICK: "OnClickBeacon",
  ON_FILE_CLICK: "OnFileClickBeacon",
  ON_BUNDLE_BASKET_CHANGE: "OnBundleBasketChangeBeacon"
};

export const EVENT = {
  [APP.HOMEPAGE]: "viewCategory",
  [APP.CATEGORY]: "viewCategory",
  [APP.SEARCH]: "viewSearchResult",
  [APP.PDP]: "viewItem",
  [APP.ORDER_CONFIRMATION]: "trackTransaction"
};

export const PARTNER_ID = {
  GB: 100712,
  FR: 100714,
  DE: 100715,
  US: 100716,
  GB_TEST: 101298,
  FR_TEST: 102301,
  DE_TEST: 102302
};

const EU_ENDPOINT = "d.eu.criteo.com";
const US_ENDPOINT = "d.us.criteo.com";

export const ENDPOINTS = {
  [PARTNER_ID.GB]: EU_ENDPOINT,
  [PARTNER_ID.FR]: EU_ENDPOINT,
  [PARTNER_ID.DE]: EU_ENDPOINT,
  [PARTNER_ID.US]: US_ENDPOINT,
  [PARTNER_ID.GB_TEST]: EU_ENDPOINT,
  [PARTNER_ID.FR_TEST]: EU_ENDPOINT,
  [PARTNER_ID.DE_TEST]: EU_ENDPOINT
};

const PLATFORM = {
  DESKTOP: "Desktop",
  MOBILE: "Mobile"
};

export const PAGE_ID = {
  HOMEPAGE_DESKTOP: `${HOMEPAGE_PREFIX}Api${PLATFORM.DESKTOP}`,
  HOMEPAGE_MOBILE: `${HOMEPAGE_PREFIX}Api${PLATFORM.MOBILE}`,
  CATEGORY_DESKTOP: `${EVENT[APP.CATEGORY]}Api${PLATFORM.DESKTOP}`,
  CATEGORY_MOBILE: `${EVENT[APP.CATEGORY]}Api${PLATFORM.MOBILE}`,
  SEARCH_DESKTOP: `${EVENT[APP.SEARCH]}Api${PLATFORM.DESKTOP}`,
  SEARCH_MOBILE: `${EVENT[APP.SEARCH]}Api${PLATFORM.MOBILE}`,
  PDP_DESKTOP: `${EVENT[APP.PDP]}Api${PLATFORM.DESKTOP}`,
  PDP_MOBILE: `${EVENT[APP.PDP]}Api${PLATFORM.MOBILE}`,
  ORDER_CONFIRMATION_DESKTOP: `${EVENT[APP.ORDER_CONFIRMATION]}Api${
    PLATFORM.DESKTOP
  }`,
  ORDER_CONFIRMATION_MOBILE: `${EVENT[APP.ORDER_CONFIRMATION]}Api${
    PLATFORM.MOBILE
  }`
};

export const APP_PAGE_ID = {
  [APP.HOMEPAGE]: {
    desktop: PAGE_ID.HOMEPAGE_DESKTOP,
    mobile: PAGE_ID.HOMEPAGE_MOBILE
  },
  [APP.CATEGORY]: {
    desktop: PAGE_ID.CATEGORY_DESKTOP,
    mobile: PAGE_ID.CATEGORY_MOBILE
  },
  [APP.SEARCH]: {
    desktop: PAGE_ID.SEARCH_DESKTOP,
    mobile: PAGE_ID.SEARCH_MOBILE
  },
  [APP.PDP]: {
    desktop: PAGE_ID.PDP_DESKTOP,
    mobile: PAGE_ID.PDP_MOBILE
  },
  [APP.ORDER_CONFIRMATION]: {
    desktop: PAGE_ID.ORDER_CONFIRMATION_DESKTOP,
    mobile: PAGE_ID.ORDER_CONFIRMATION_MOBILE
  }
};

export const PLATFORM_PARAMETER = {
  desktop: "d",
  mobile: "m"
};

export const NO_CALL = {
  displayAds: "oa",
  sponsoredProducts: "pd"
};
